import React from 'react';

import { TableRow } from '../ControlTab/utils';
import { DataTableColumn } from '@/components/DataTable';

export const createSummaryLeftColumns = (
  StatusIndicatorComponent: React.ComponentType<{ status: '0' | '1' }>
): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.value !== '0' && row.value !== '1') {
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
        );
      }
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    needPadding: row =>
      row.value !== '0' && row.value !== '1' && row.unit !== '',
    renderCell: ({ row }) => {
      if ((row.value === '0' || row.value === '1') && row.unit === '') {
        return <StatusIndicatorComponent status={row.value as '0' | '1'} />;
      }
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
    }
  }
];

export const createSummaryRightColumns = (): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
    }
  }
];

export const createSummaryLeftRows = (initialData: any): TableRow[] => {
  if (!initialData?.synchonize) return [];
  return initialData.synchonize as TableRow[];
};

export const createSummaryRightRows = (initialData: any): TableRow[] => {
  if (!initialData?.synchonize) return [];
  return initialData.synchonize as TableRow[];
};

export const createTemperaturesColumns = (): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      const celsiusValue = parseFloat(row.value as string);
      const fahrenheitValue = (celsiusValue * 9) / 5 + 32;
      const formattedValue = fahrenheitValue.toFixed(1);

      return (
        <span style={{ color: 'var(--main-blue-color)' }}>
          {formattedValue}
        </span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      return <span>{row.unit}</span>;
    }
  }
];

export const createTemperaturesRows = (initialData: any[]): TableRow[] => {
  if (!initialData || !Array.isArray(initialData) || initialData.length === 0)
    return [];
  return initialData as TableRow[];
};
